module.exports = __webpack_public_path__ + "img/Rectangle39.b4458594.svg";